import { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Icon, SidebarItem } from '@components';
import MENU_ITEMS from '@constants/sideMenu';
import Logo from '@assets/images/logo.svg';
import LogoLetter from '@assets/images/logo-letter.svg';
import { AUTH } from '@constants/routes';
import { clearAllLocalStorageItems } from '@utils/storage';
import { SideNavProps } from 'types/main-layout';
import { useDispatch } from 'react-redux';
import { resetUserState } from '@features/authentication/userSlice';
import { api } from '@core/baseApi';

const SideNavBar: FC<SideNavProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSidebarOpen, setSideBarOpen] = useState<boolean>(false);

  const openSidebar = () => {
    setSideBarOpen(true);
  };

  const closeSidebar = () => {
    setSideBarOpen(false);
  };

  const onClickLogout = () => {
    dispatch(api.util.resetApiState());
    clearAllLocalStorageItems();
    dispatch(resetUserState());
    navigate(AUTH.LOGIN);
  };
  return (
    <div
      onMouseEnter={openSidebar}
      onMouseLeave={closeSidebar}
      className={`absolute left-0 top-0 z-50 flex h-screen flex-col bg-theme shadow-sm transition-all duration-300 ease-in-out ${
        isSidebarOpen ? 'w-270' : 'w-72'
      }`}
    >
      {/* Fixed Logo */}
      <div className="h-12 shrink-0 px-6 pb-6 pt-8">
        <img
          src={Logo}
          alt="Tara Logo"
          className={`${isSidebarOpen ? '' : 'hidden'}`}
          width={66}
          height={45}
        />

        <img
          src={LogoLetter}
          alt="Tara"
          className={`${
            isSidebarOpen ? 'hidden' : 'ml-1 flex items-center justify-center'
          }`}
          width={18}
          height={23}
        />
      </div>

      {/* Scrollable Menu */}
      <div className="sidebar-scroll mt-6 flex-1 overflow-y-auto py-3">
        <div className="flex flex-col gap-3">
          {MENU_ITEMS.map((item: any) => {
            const { route } = item;
            const isCurrentRoute = location.pathname.startsWith(route);

            return (
              <SidebarItem
                key={item.label}
                item={item}
                path={route}
                isCurrentRoute={isCurrentRoute}
                isSidebarOpen={isSidebarOpen}
              />
            );
          })}
        </div>
      </div>

      {/* Fixed Logout */}
      <div
        className="mx-4 mb-4 flex shrink-0 cursor-pointer items-center gap-3 rounded-lg bg-errorLite p-3"
        onClick={onClickLogout}
        role="presentation"
      >
        <Icon className="size-6 text-error700" name="logout" />
        <div className="truncate text-center text-base font-semibold text-error700">
          Logout
        </div>
      </div>
    </div>
  );
};
export default SideNavBar;
